import ViewQuizSubmissionLayout from 'components/ViewQuizSubmission/ViewQuizSubmissionLayout';

const Mobile = (props) => <ViewQuizSubmissionLayout device={'mobile'} {...props} />;

export default Mobile;
